import { get } from 'lodash';

const didFieldChange = (props, nextProps, field) => {
  const value = get(props, `fields.${field}.value`);
  const nextValue = get(nextProps, `fields.${field}.value`);
  return value !== nextValue;
};

export default didFieldChange;
